import { Component } from '@angular/core';
import { Router } from "@angular/router";


@Component({
    templateUrl: './home.page.html',
})

export class AdminHomePage {




    constructor(public router: Router) { }
}



// WEBPACK FOOTER //
// D:/Works/Safetyminder/Safetyminder/Admin/src/app/admin/pages/home.page.ts